import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/store/auth";

const routes = [
    {
        path: "/",
        component: () => import("@/pages/Site-Portal.vue"),
        meta: { title: "章简合知识产权｜专业商标服务与复杂案件解决方案" },
    },
    {
        path: "/login",
        component: () => import("@/pages/LoginPage.vue"),
        meta: { title: "登录｜章简合知识产权", noindex: true },
        children: [],
    },
    {
        path: "/home",
        component: () => import("@/pages/HomePage.vue"),
        meta: { title: "管理中心｜章简合知识产权", noindex: true },
        children: [
            {
                path: "",
                redirect: "/home/index",
            },
            {
                path: "account",
                component: () => import("@/pages/Account.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            }, {
                path: "account/edit",
                component: () => import("@/pages/AccountEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "product",
                component: () => import("@/pages/Product2.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"], title: "产品管理｜章简合知识产权", noindex: true },
            },
            {
                path: "product/edit",
                component: () => import("@/pages/Product2Edit.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"], title: "产品详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "opportunity",
                component: () => import("@/pages/Opportunity.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "商机｜章简合知识产权", noindex: true },
            },
            {
                path: "opportunity/edit",
                component: () => import("@/pages/OpportunityEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "商机详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "task",
                component: () => import("@/pages/Task.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "任务｜章简合知识产权", noindex: true },
            },
            {
                path: "file",
                component: () => import("@/pages/CaseFile.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "文件中心｜章简合知识产权", noindex: true },
            },
            {
                path: "file/editor",
                component: () => import("@/pages/CaseFileEditor.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"], title: "在线编辑｜章简合知识产权", noindex: true },
            },
            {
                path: "lead",
                component: () => import("@/pages/Lead.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"], title: "Lead 管理｜章简合知识产权", noindex: true },
            },
            {
                path: "lead/edit",
                component: () => import("@/pages/LeadEdit.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"], title: "Lead 详细信息｜章简合知识产权", noindex: true },
            },
            {
                path: "index",
                component: () => import("@/pages/IndexPage.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "territory",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "territory/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "profile",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "profile/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "record-type",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"] },
            },
            {
                path: "record-type/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"] },
            },
            {
                path: "object",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"] },
            },
            {
                path: "object/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["ADMIN"] },
            },
            {
                path: "permission-set",
                component: () => import("@/pages/PermissionSet.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "user-role",
                component: () => import("@/pages/SetupObjectList.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "user-role/edit",
                component: () => import("@/pages/SetupObjectEdit.vue"),
                meta: { requiresAuth: true, role: ["USER", "ADMIN"] },
            },
            {
                path: "user",
                component: () => import("@/pages/UserManagement.vue"),
                meta: { requiresAuth: false, role: ["ADMIN"] },
            },
            {
                path: "user/edit",
                component: () => import("@/pages/UserSetupStandard.vue"),
                meta: { requiresAuth: false, role: ["ADMIN"] },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.afterEach((to) => {
    document.title = to.meta.title || "章简合知识产权";

    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
    }
    robotsMeta.setAttribute(
        "content",
        to.meta.noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large"
    );
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();

    // 如果目标页面需要登录 && 没有 Token，则跳转到登录页
    if (to.meta.requiresAuth && !authStore.token) {
        next("/login");
    } else {
        next(); // 继续访问
    }
});

export default router;
